module.exports = __webpack_public_path__ + "img/1512592609.dc69ba84.jpg";